export default {
  chart: {},
  chartAccounts: [],
  chartNames: [],
  chartName: null,
  originalChartName: null,
  canModifyByAssignment: false,
  r2rAccountValues: [],
  importStatusValues: [],
  isSavingChartInProgress: false,
  isSavingInProgress: false,
  chartToEdit: null,
  fetchChartAccountsError: '',
  chartAccountsLoading: false,
  chartAccountsImporting: false,
  isDeletingChartInProgress: false,
  isRemovingChartAccountInProgress: false,
  isFetchingInitialDataForAddAndEditChartAccountModal: false,
};
